import React from 'react'

const Courses = () => {
  return (
    <div><h3>Tis page is still development.Please come back later</h3></div>
  )
}

export default Courses